import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Campaign } from "../../models/campaign.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";

let PeopleTabsComponent = {
    selector: "vcPeopleTabs",
    templateUrl: "/angular/components/people/people-tabs.component.html",
    bindings: {
        activeTab: "=?",
        create: "=?",
        showing: "=?",
        provider: "=?",
        itemType: "=?",
        function: "&?",
        hasEffort: "=?",
        linkOrigin: "=?",
        selectedStreet: "=?",
        selectedGroup: "=?",
        selectedLocation: "=?",
        showFilterButton: "=?",
        filter: "=?",
    },
    controller: class PeopleTabsController {
        // * bindings for typescript compiler *
        public activeTab?: any;
        public create?: any;
        public showing?: any;
        public provider?: any;
        public itemType?: any;
        public function?: any;
        public hasEffort?: any;
        public linkOrigin?: string;
        public selectedStreet?: any;
        public selectedGroup?: any;
        public selectedLocation?: any;
        public showFilterButton?: any;
        public filter?: any;
        // ************************************

        private readonly __app_type: string;
        private activeCampaign: Campaign;
        private $scope: any;
        private $location: any;
        private $route: any;
        private $window: any;
        private $cookies: any;
        private dialog: DialogUtils;

        public navigationBarService: NavigationBarHelperService;
        public campaignDataProvider: CampaignDataProvider;
        private filterDataProvider: FilterDataProvider;
        private effortDataProvider: EffortDataProvider;
        private groupDataProvider: GroupDataProvider;

        public selectedEffort: any;
        public isLeaderView: boolean = false;
        public essentialsMode: boolean;
        public efforts: any;
        public showingDummyData: boolean;
        public permissionProvider: PermissionCheck;
        public screen: ScreenUtils;
        public __env: any;

        constructor(
            $scope: any,
            __env: any,
            $location: any,
            $route: any,
            $cookies: any,
            $window: any,
            __app_type: string,
            NavigationBarHelperService: NavigationBarHelperService,
            CampaignDataProvider: CampaignDataProvider,
            FilterDataProvider: FilterDataProvider,
            EffortDataProvider: EffortDataProvider,
            GroupDataProvider: GroupDataProvider,
            PermissionCheck: PermissionCheck,
            ScreenUtils: ScreenUtils,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.$location = $location;
            this.$route = $route;
            this.$window = $window;
            this.$cookies = $cookies;
            this.__app_type = __app_type;
            this.screen = ScreenUtils;
            this.dialog = DialogUtils;

            this.navigationBarService = NavigationBarHelperService;
            this.campaignDataProvider = CampaignDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.groupDataProvider = GroupDataProvider;
            this.permissionProvider = PermissionCheck;

            this.selectedEffort = this.effortDataProvider.getSelectedEffort();
            this.isLeaderView = this.__app_type == "LEADER";
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.essentialsMode = this.activeCampaign.campaignstatusid == "5";
        }

        $onInit() {
            if (this.hasEffort) {
                this.effortDataProvider.getSelectedEffort().then((effort) => {
                    if (effort) {
                        this.setEffort(effort);
                    }
                });
                this.effortDataProvider.getAllEfforts().then((efforts) => {
                    this.efforts = efforts;
                });
            }
        }

        enableSampleData($event) {
            this.campaignDataProvider.restoreSampleData().then(() => {
                this.$window.location.reload();
            });
        }

        showEssentialsDialog(ev: any): void {
            this.dialog.show({
                component: "vc-feature-disabled-dialog",
                targetEvent: ev,
                size: "large",
                scope: this.$scope,
                locals: {
                    essentials: true,
                },
            });
        }

        backButtonPressed(location: string): void {
            if (this.linkOrigin == "dashboards") {
                this.$window.location = "/#/";
            } else if (this.linkOrigin == "assignments") {
                this.$window.location = "/#/assignments";
            } else {
                this.navigateTo(location);
            }
        }

        navigateTo(location: string): void {
            if (this.isLeaderView) {
                this.$window.location =
                    "/leader.php#/leader_" +
                    location +
                    "?filter=" +
                    JSON.stringify(
                        this.filterDataProvider.appliedFilter.nonEmptyValues()
                    );
            } else {
                this.$window.location =
                    "/#/" +
                    location +
                    "?filter=" +
                    JSON.stringify(
                        this.filterDataProvider.appliedFilter.nonEmptyValues()
                    );
            }
        }

        setGroupsListView(type: string): void {
            this.$cookies.put("listView", type);
            this.groupDataProvider.listView = type;

            if (this.selectedGroup) {
                const encodedGroup = encodeURIComponent(
                    JSON.stringify({
                        gid: this.selectedGroup.gid,
                        gname: this.selectedGroup.gname,
                    })
                );
                this.$window.location =
                    "/#/" +
                    type +
                    "?filter=" +
                    JSON.stringify(
                        this.filterDataProvider.appliedFilter.nonEmptyValues()
                    ) +
                    "&group=" +
                    encodedGroup;
            }
        }

        openColumnsDialog(columns: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-columns-dialog",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    ariaLabel: "Choose which columns you see.",
                    class: "columns-dialog",
                    locals: {
                        columns: columns,
                        sortable: true,
                    },
                })
                .then((columns: any) => {
                    let localStorage: any;
                    if (this.isLeaderView) {
                        this.campaignDataProvider
                            .getOrganisations()
                            .then((organisation) => {
                                localStorage = organisation.getLocalStorage();
                                localStorage[this.itemType + "Columns"] =
                                    columns;
                                organisation.saveLocalStorage();
                            });
                    } else {
                        localStorage = this.activeCampaign.getLocalStorage();
                        localStorage[this.itemType + "Columns"] = columns;
                        this.activeCampaign.saveLocalStorage();
                    }

                    this.provider.columns.splice(
                        0,
                        this.provider.columns.length
                    );
                    angular.forEach(columns, (column) => {
                        this.provider.columns.push(column);
                    });
                });
        }

        clearLocation(): void {
            this.selectedLocation.id = null;
            this.$location.search(
                "location",
                JSON.stringify(this.selectedLocation)
            );
        }

        setEffort(selectedEffort: any): void {
            this.selectedEffort = selectedEffort;
            this.provider.setEffort(selectedEffort.id);
            this.effortDataProvider.setSelectedEffort(selectedEffort);
        }
    },
};

angular
    .module("people")
    .component(PeopleTabsComponent.selector, PeopleTabsComponent);
